import * as React from "react";
import type { SVGProps } from "react";
const VolumeLevelSvg = (props: SVGProps<SVGSVGElement>) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_437_9907)">
            <path d="M12.0381 10.5C12.6534 9.44348 12.9856 8.235 13 7C12.9856 5.765 12.6534 4.55652 12.0381 3.5" stroke={props.stroke} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10.1191 5.5C10.4535 5.92029 10.625 6.45518 10.6001 7C10.625 7.54482 10.4535 8.07971 10.1191 8.5" stroke={props.stroke} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2.90475 5.00026H1.4619C0.937985 5.00026 0.5 5.45559 0.5 6.00026V8.00026C0.5 8.54492 0.937985 9.00026 1.4619 9.00026H2.90475L6.66579 11.8102C7.2865 12.2567 8.17841 11.7866 8.19521 11.0002V3.00024C8.21323 2.2134 7.3748 1.74251 6.75236 2.19024L2.90475 5.00026Z" stroke={props.stroke} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_437_9907">
                <rect width="14" height="14" fill="white" />
            </clipPath>
        </defs>
    </svg>


);
export default VolumeLevelSvg;
